// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"369":"socials","725":"wechatpay","775":"bulk","825":"english","942":"socials-eng","964":"bulk-eng"}[chunkId] || chunkId) + "." + {"191":"a8406c21","369":"1bb6e25b","503":"94563db0","725":"a61cda4b","775":"e7af30db","825":"01ded9a0","887":"af844f4f","942":"8d55c215","964":"41e36cab"}[chunkId] + ".css";
};